import Vue from 'vue';



 let app = {
    init() {
        var self = this;

        Offline.on('confirmed-up',function () {
            self.client.netStatus = true;
        });

        Offline.on('confirmed-down',function () {
            self.client.netStatus = false;
        });

    },
    getCsrf(){
        return $("meta[name=csrf-token]").attr("content");
    },
    client:{
        netStatus:true
    },
    helpers:{
        decOfNum(number, titles){
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
        },
        array:{
            removeByValue(array,value){
                let index = array.indexOf(value);

                if(index!=-1){

                    array.splice(index, 1);
                }

                return array;
            },
            in: function (value, array) {
                return array.indexOf(value) > -1;
            }
        }
    },
    initPanel() {
        $('.panel').on('hide.bs.collapse', function () {
            var $angle = $(this).find('.angle');
            $angle.removeClass('fa-angle-up');
            $angle.addClass('fa-angle-down');
        });
        $('.panel').on('show.bs.collapse', function () {
            var $angle = $(this).find('.angle');
            $angle.addClass('fa-angle-up');
            $angle.removeClass('fa-angle-down');
        });
    },
    isMac() {
        if (navigator.userAgent.indexOf ('Mac')!= -1) {
            return true
        }
        else {
            return false
        }
    }
};


let os = 0;
if (navigator.userAgent.indexOf ('Windows') != -1) os = 1;
if (navigator.userAgent.indexOf ('Linux')!= -1) os = 2;
if (navigator.userAgent.indexOf ('Mac')!= -1) os = 3;

$(function () {
    app.init();
    $.fn.select2.defaults.set("delay",250);

});
Vue.directive('select2', {
    bind: function (el, binding, node) {
        $(el)
            .on("select2:select", function(e) {
                node.context[binding.expression] = $(this).val();
            })
            .on("select2:change", function(e) {
                node.context[binding.expression] = $(this).val();
            })
            .on("select2:unselect", function(e) {
                node.context[binding.expression] = '';
            });
    }
});


$(document).ready(function(){
    $("#calendar-slider, #info-slider, #carousel-example").swipe( {
        swipeLeft: function() {
            $(this).carousel("next");
        },
        swipeRight: function() {
            $(this).carousel("prev");
        },
        allowPageScroll: "vertical"
    });
    $('form input, form textarea').keydown(function() {
        var iputID = $(this).attr("id");
        $(this).parents('form').yiiActiveForm('updateAttribute', iputID, '');
    });

    $(window).scroll(function(event){
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            $("#back-to-top").addClass("back-to-top_show");
        } else {
            $("#back-to-top").removeClass("back-to-top_show");
        }
    });
    $("#back-to-top").on('click',function(){
        $('html, body').animate({scrollTop: 0}, 'slow');
        return false;
    });




});
$( document ).ready(function() {
    var elpar_1 = $('.cert-list').height();
    if ($('.cert-list').length) {
        var elpar_2 = $('.cert-list').offset().top;
        var winH = elpar_1 + elpar_2 + 150;
        $('.cert-list li').hover(function () {
            var elhtml = $(this).find('.popover-block');
            var posit = elhtml.offset().top;
            var elH = elhtml.height();
            if (winH > (posit + elH)) {
                elhtml.removeClass('bottom-edge');

            }
            else {
                elhtml.addClass('bottom-edge');
            }
        });
    }
    var showingToolTip;
    document.addEventListener('mouseover', function(e){
        if(!e.target.hasAttribute('data-tooltip'))return;
        target = e.target;
        var value = target.getAttribute('data-tooltip');
        var p = document.createElement('p');
        p.innerHTML = value;
        p.classList.add('tooltip-map');
        document.querySelector('.new-user').appendChild(p);

        showingToolTip = p;
        window.addEventListener('mousemove', function (ev) {
            ev = window.event || ev;
            X=ev.pageX;
            Y=ev.pageY;

            function move() {
                p.style.left = X + 10 + 'px';
                p.style.top = Y + 10 + 'px';
                setTimeout(move, 20);
            }
            move();

        });
    });
    document.addEventListener('mouseout', function(e) {
        if(showingToolTip){
            document.querySelector('.new-user').removeChild(showingToolTip);
            showingToolTip = null;
        }
    });
});

$(function () {

    $.fn.clickToggle = function(func1, func2) {
        var funcs = [func1, func2];
        this.data('toggleclicked', 0);
        this.click(function() {
            var data = $(this).data();
            var tc = data.toggleclicked;
            $.proxy(funcs[tc], this)();
            data.toggleclicked = (tc + 1) % 2;
        });
        return this;
    };

    if ($(".input-style").hasClass("error_input"))
        $(".error-alert").css('display', 'block');
// Фокус search header

    $(".search input").focus(function () {
        $(".search .fa").css('color', '#00b1ac');
    });
    $(".search input").blur(function () {

        $(".search .fa").css('color', '#000');
    });

    $(document).on('click', function (e) {
        $('[data-toggle="popover"],[data-original-title]').each(function () {
            //the 'is' for buttons that trigger popups
            //the 'has' for icons within a button that triggers a popup
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                (($(this).popover('hide').data('bs.popover')||{}).inState||{}).click = false  // fix for BS 3.3.6
            }
        });
    });




//  Фокус псевдо textarea
    $(".answer-area textarea").focus(function () {
        $(".answer-area .for-guote").css('border-color', '#8bcbc9');
    });
    $(".answer-area textarea").blur(function () {
        $(".answer-area .for-guote").css('border-color', '#e3e7e7');
    });





// Свернуть аккардеон bootstrap
    $('.collapse-xs').collapse('hide');

// Трансляци правка вопросов {не готово}
    $('#post_256 .fa-pencil').click(function(){

        $('#post_256 p').attr('contenteditable', 'true');
        $('#post_256 p').addClass('input-style');
        $('#post_256').append('<button class="submit-btn" type="submit"><span class="text">Применить</span></button>');
        $('#post_256 .btn-edit').css('display', 'none');

        $('.submit-btn').click(function(){
            $('#post_256 p').attr('contenteditable', 'false');
            $('#post_256 p').removeClass('input-style');
            $('#post_256 .submit-btn').remove();
        });


    });

//Архив  Видео
    $('#video-play').click(function () {
        if (!$('.video-block').data('status')) {
            $('.video-block').css('width', '100%');
            $('.video-block').slideDown("slow");
            $('#video-play .text').text('Свернуть видео');
            // $('#video-play').removeClass('oring-btn-small').addClass('green-btn-small');
            $('#video-play .fa').removeClass('fa-file-video-o').addClass('fa-stop');
            $("html, body").animate({ scrollTop: 0 }, 600);
            $('.video-block').data('status', true);
            $('.left-btn, .right-btn').css('bottom', '18%')

        } else {
            $('.video-block').slideUp("slow");
            $('#video-play .text').text('Смотреть видео');
            // $('#video-play').removeClass('green-btn-small').addClass('oring-btn-small');
            $('#video-play .fa').removeClass('fa-stop').addClass('fa-file-video-o');
            $("html, body").animate({ scrollTop: 0 }, 600);
            $('.video-block').data('status', false);
            $('.left-btn, .right-btn').css('bottom', '50%')
        }
    });

//Scrollspy
    var lastId,
        topMenu = $("#myScrollspy"),
        topMenuHeight = topMenu.outerHeight()+100,
        // All list items
        menuItems = topMenu.find("a"),
        // Anchors corresponding to menu items
        scrollItems = menuItems.map(function(){
            var item = $($(this).attr("href"));
            if (item.length) { return item; }
        });
// Bind click handler to menu items
// so we can get a fancy scroll animation
    menuItems.click(function(e){
        var href = $(this).attr("href"),
            offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+1;
        $('html, body').stop().animate({
            scrollTop: offsetTop
        }, 300);
        e.preventDefault();
    });
// Bind to scroll
    $(window).scroll(function(){
        // Get container scroll position
        var fromTop = $(this).scrollTop()+topMenuHeight;

        // Get id of current scroll item
        var cur = scrollItems.map(function(){
            if ($(this).offset().top < fromTop)
                return this;
        });
        // Get the id of the current element
        cur = cur[cur.length-1];
        var id = cur && cur.length ? cur[0].id : "";

        if (lastId !== id) {
            lastId = id;
            // Set/remove active class
            menuItems
                .parent().removeClass("active")
                .end().filter("[href='#"+id+"']").parent().addClass("active");
        }
    });





// Visible pass
    $('.pass-input .fa').clickToggle(function(){
            $('.pass-input input').attr('type', 'text');
            $('.pass-input .fa').removeClass('fa-eye-slash').addClass('fa-eye');

        },
        function(){
            $('.pass-input input').attr('type', 'password');
            $('.pass-input .fa').removeClass('fa-eye-slash').addClass('fa-eye-slash');

        }  );



// Active accordion btn
    $('.search-block').on('show.bs.collapse', function () {
        $('#search-user-btn').addClass('active');
    });
    $('.search-block').on('hide.bs.collapse', function () {
        $('#search-user-btn').removeClass('active');
    });
    $('.add-user').on('show.bs.collapse', function () {
        $('.add-users-btn').addClass('active');
    });
    $('.add-user').on('hide.bs.collapse', function () {
        $('.add-users-btn').removeClass('active');
    });


    app.initPanel();

});



//Липкий блок
$(document).ready(function(){
    if ($('#sticky').offset() ) {
        $(function() {
            var box = $('#sticky');
            var topValue = box.offset().top - parseFloat(box.css('marginTop').replace(/auto/, 0));
            $(window).scroll(function(){
                var windowpos = $(window).scrollTop();
                if(windowpos < topValue) {
                    box.css('position', 'static');
                } else {
                    box.css('position', 'fixed');
                    box.css('top', 0);
                }
            });
        });
    }

});
// Triangle test drop
$(function () {
    $('.header .panel-title a').click(function () {
        if (!$('.header.triangle').data('status')) {
            $('.header .triangle').css('border-width', '0px 4px 5px 4px').css('border-color', 'transparent transparent #000 transparent');
            $('.header .triangle').data('status', true);
        } else {
            $('.header .triangle').css('border-width', '5px 4px 0px 4px').css('border-color', '#000 transparent transparent  transparent');
            $('.header .triangle').data('status', false);
        }
    });
    $('.test .panel-title a').click(function () {
        if (!$('.fa-angle-down').data('status')) {
            $('.fa-angle-down').css('transform', 'rotate(180deg)');
            $('.fa-angle-down').data('status', true);
        } else {
            $('.fa-angle-down').css('transform', 'rotate(0deg)');
            $('.fa-angle-down').data('status', false);
        }
    });
});

// Init Select2
$(document).ready(function () {
    //Fix  bag video chrome
    function pause() {
        if (!element) return;
        element.pause();
        //element.autoplay = false;
    }
    $(".select-filter").select2({
        minimumResultsForSearch: Infinity,
        theme: "select-filter"
    });
    $(".tags").select2({
        tags: false,
        theme: "select-tags",
        placeholder: "Выберите специализацию",
    });
    $(".search-sity").select2({
        placeholder: "Введите город",
        theme: 'select-city',
        allowClear: true,
        doReset:true,
        doToggle:false,
        doOrder:false,
    });
    $(".search-name").select2({
        placeholder: "Поиск по фамилии или телефону",
        theme: 'select-name',
        allowClear: true,
    });
    $(".filter-table").select2({
        theme: 'filter-table',
        minimumResultsForSearch: Infinity,
    });
    $("#login-form-password").keydown(function() {

        $(".field-login-form-password").removeClass('has-error');
        $(".field-login-form-password").find('.help-block').remove();

    });
    appear({
        init: function init(){},
        elements: function elements(){
            return document.getElementsByClassName('map-number-block');

        },
        appear: function appear(el){
            var parrentClass = '.' + el.className;
            $(parrentClass + ' ' + '.timer').countTo({
                speed: 1000,
                refreshInterval: 60,
                formatter: function (value, options) {
                    return value.toFixed(options.decimals);
                }
            });
        },
        disappear: function disappear(el){
        },
        bounds: -200,
        reappear: false
    });

    $(window).scroll(function() {

        var st = $(this).scrollTop() /40;

        $(".fix-block").css({
            "transform" : "translate3d(0px, " + st  + "%, .01px)",
            "-webkit-transform" : "translate3d(0px, " + (st* -1)  + "%, .01px)"
        });


    });

});

// Init magnific-popup
$(document).ready(function() {
    $('.image-link').magnificPopup({type:'image'});
    $('.test-popup-link').magnificPopup({
        type: 'image'
        // other options
    });
});



function doNotShowKarmBanner() {

    try {

        $.ajax({
            url: '/site/hide-karm-banner',
            dataType: "json",
            success: function (data) {

            },
            fail: function () {

                throw new Error('Ошибка получении данных');

            }
        });

    } catch (e) {

        //Отправить данные об ошибке в систему логов

        console.error(e);

    }

}

(function ($) {
    $.fn.countTo = function (options) {
        options = options || {};
        return $(this).each(function () {
            // set options for current element
            var settings = $.extend({}, $.fn.countTo.defaults, {
                from:            $(this).data('from'),
                to:              $(this).data('to'),
                speed:           $(this).data('speed'),
                refreshInterval: $(this).data('refresh-interval'),
                decimals:        $(this).data('decimals')
            }, options);

            // how many times to update the value, and how much to increment the value on each update
            var loops = Math.ceil(settings.speed / settings.refreshInterval),
                increment = (settings.to - settings.from) / loops;

            // references & variables that will change with each update
            var self = this,
                $self = $(this),
                loopCount = 0,
                value = settings.from,
                data = $self.data('countTo') || {};

            $self.data('countTo', data);

            // if an existing interval can be found, clear it first
            if (data.interval) {
                clearInterval(data.interval);
            }
            data.interval = setInterval(updateTimer, settings.refreshInterval);

            // initialize the element with the starting value
            render(value);

            function updateTimer() {
                value += increment;
                loopCount++;

                render(value);

                if (typeof(settings.onUpdate) == 'function') {
                    settings.onUpdate.call(self, value);
                }

                if (loopCount >= loops) {
                    // remove the interval
                    $self.removeData('countTo');
                    clearInterval(data.interval);
                    value = settings.to;

                    if (typeof(settings.onComplete) == 'function') {
                        settings.onComplete.call(self, value);
                    }
                }
            }

            function render(value) {
                var formattedValue = settings.formatter.call(self, value, settings);
                $self.html(formattedValue);
            }
        });
    };
    $.fn.countTo.defaults = {
        from: 0,               // the number the element should start at
        to: 0,                 // the number the element should end at
        speed: 1000,           // how long it should take to count between the target numbers
        refreshInterval: 100,  // how often the element should be updated
        decimals: 0,           // the number of decimal places to show
        formatter: formatter,  // handler for formatting the value before rendering
        onUpdate: null,        // callback method for every time the element is updated
        onComplete: null       // callback method for when the element finishes updating
    };
    function formatter(value, settings) {
        return value.toFixed(settings.decimals);
    }
}(jQuery));

// jQuery(function ($) {
//
//     // start all the timers
//     // $('.timer').each(count);
//
//     function count(options) {
//         var $this = $(this);
//         options = $.extend({}, options || {}, $this.data('countToOptions') || {});
//         $this.countTo(options);
//     }
// });

// Close mobile menu click outside
$(document).click(function (event) {
    var clickover = $(event.target);
    var $navbar = $(".navbar-collapse");
    var _opened = $navbar.hasClass("in");
    if (_opened === true && !clickover.hasClass("navbar-toggle")) {
        $navbar.collapse('hide');
    }
});










